import angular from 'angular';

let MeDetailController = function ($filter, $mdDialog, $scope, $state, Restangular, Toast, Group) {
  let $ctrl = this;

  $ctrl.me;
  $ctrl.isPasswordVisible = false;
  $ctrl.isCurrentPasswordVisible = false;
  $ctrl.currentPassword;

  angular.extend($ctrl, {
    clearImage,
    clearForm,
    handleSave
  });

  activate();

  function activate() {
    clearForm();

    angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);

    $ctrl.uiState = 'LOADING';

    loadDomainResources()
      .then(result => {
        $ctrl.access_groups = result[0];

        loadResource();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function clearImage() {
    angular.element(document.querySelector('#fileInput')).val(undefined);
    $ctrl.myImage = '';
    $ctrl.myCroppedImage = '';
    $ctrl.fileName = undefined;
    $ctrl.me.image_uri = null;
  }

  function clearForm(form) {
    $ctrl.me = {};

    if (form) {
      form.email.$$element[0].value = '';
      form.$setPristine(); 
      form.$setUntouched();
    }

    $ctrl.myImage = '';
    $ctrl.myCroppedImage = '';
    $ctrl.fileName = undefined;
  }

  function handleSave(form, me) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    me.image_base64 = $ctrl.myCroppedImage;

    $ctrl.currentPassword = me.current_password;

    $ctrl.saving = true;

    me.save()
      .then(response => {
        Toast.success($filter('translate')('me-detail-save-success'));
        response.current_password = $ctrl.currentPassword;
        $ctrl.me = response;
        $ctrl.saving = false;
        window.history.back();
      })
      .catch(err => {
        let defaultErrMsg = $filter('translate')('common-server-error');
        let fourOThreeMsg = $filter('translate')('me-detail-403-error') 
        let message = err.status == 403 ? fourOThreeMsg : defaultErrMsg;
        Toast.error(message);
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }

  // Local functions
  function handleFileSelect(event) {
    let file = event.currentTarget.files[0];

    if (!file) {
      return;
    }

    let reader = new FileReader();
    reader.onload = function (event) {
      $ctrl.myImage = event.target.result;
      $scope.$apply();
      $ctrl.fileName = file.name;
      showCropDialog(event);
    };

    reader.readAsDataURL(file);
  }

  function showCropDialog(event) {
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template:
      '<md-dialog aria-label="List dialog">' +
      '  <md-dialog-content>'+
      '    <ui-cropper'+
      '      image="myImage"'+
      '      area-type="circle"'+
      '      chargement="loadingText"'+
      '      result-image-size="{w: 200,h: 200}"'+
      '      result-image="myCroppedImage" canvas-scalemode="true">'+
      '    </ui-cropper>'+
      '  </md-dialog-content>' +
      '  <md-dialog-actions>' +
      '    <md-button ng-click="cancel()">' +
      '      Cancelar' +
      '    </md-button>' +
      '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
      '      Feito' +
      '    </md-button>' +
      '  </md-dialog-actions>' +
      '</md-dialog>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false
    })
    .then(function(myCroppedImage) {
      $ctrl.myCroppedImage = myCroppedImage;
      $ctrl.myImage = '';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";
    $scope.loadingText = 'Carregando';
    $scope.myImage = $ctrl.myImage;
    $scope.myCroppedImage = $ctrl.myCroppedImage;

    $scope.hide = function() {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.cancel();
    };

    $scope.cropImage = function(myCroppedImage) {
      $mdDialog.hide(myCroppedImage);
    }
  }

  function loadResource(id){
    Restangular.service('me')
      .one()
      .get()
      .then(me => {
        console.log('me:' ,  me);
        $ctrl.me = me;
        $ctrl.uiState = 'COMPLETE';
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Group.index());

    return Promise.all(promises);
  }

}

MeDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Restangular', 'Toast', 'Group'];

export default MeDetailController;


// WEBPACK FOOTER //
// ./client/app/components/me/me.controller.js